<template>

    <div>

        <ul class="w-full flex justify-around mb-0 list-none flex-wrap pt-1 pb-2 flex-row">
            <li class="-mb -px ms-1 me-2 last:mr-0 flex-auto text-center">
                <a class="text-xs font-bold uppercase px-5 py-1 shadow-lg rounded block leading-normal" v-on:click="callItemIsSelected(1)" v-bind:class="{'text-pink-600 bg-white': openedTab !== 1, 'text-white bg-blue-600': openedTab === 1}">
                
                    <font-awesome-icon icon="list-alt" size="2x"/> 

                <!-- {{$t('menu.list')}} -->
                </a>
            </li>

            <li class="-mb-px me-2 last:mr-0 flex-auto text-center">
                <a class="text-xs font-bold uppercase px-5 py-1 shadow-lg rounded block leading-normal" v-on:click="callItemIsSelected(2)" v-bind:class="{'text-pink-600 bg-white': openedTab !== 2, 'text-white bg-blue-600': openedTab === 2}">
                    
                    <font-awesome-icon icon="map" size="2x"/> 

                <!-- {{$t('menu.map')}} -->
                </a>
            </li>

            <!-- <li class="-mb-px me-2 last:mr-0 flex-auto text-center">
                <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="callItemIsSelected(3)" v-bind:class="{'text-pink-600 bg-white': openedTab !== 3, 'text-white bg-blue-600': openedTab === 3}">
                    
                {{$t('memberships.classes')}}
                </a>
            </li> -->
        </ul>
        
    </div>
    
</template>


<script>


export default {

    components:{

    },

    props:{

        itemIsSelected: {

            type: Function
        }
    },

    methods:{

        callItemIsSelected(value){

            // console.log(`value: ${value}`);

            this.openedTab = value

            this.itemIsSelected(value);
        }

    },

    data: function(){

        return{

            openedTab: 1,

        }
    }

}
</script>

<style>

</style>